<script setup>
import StarsRating from "../ui/StarsReitnig.vue";
import { ref, onMounted } from "vue";
import axios from "axios";
import { useStore } from "vuex";
const store = useStore();
const user = store.state.user;
const token = user.bearer;
const companies = ref([]);
const getCompanies = async () => {
  try {
    const response = await axios.get(
      "https://api.feedback.agl.center/index.php/companies",
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    companies.value = response.data;
    await goRaiting();
  } catch (error) {
    console.error(error);
  }
};
const goRaiting = async () => {
  for (const company of companies.value) {
    const formData = new FormData();
    let params = {
      action: "index.php/ratings/average?company_id=" + company.id,
      method: "GET",
    };
    for (let key in params) {
      formData.append(key, params[key]);
    }
    const response = await axios.post(
      `https://feedback.agl.center/ApiConnector.php`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    company.rating = response.data.average;
  }
};
onMounted(() => {
  getCompanies();
  const rects = document.querySelectorAll("rect");

  const animateRandomRects = () => {
    const rectsArray = Array.from(rects);
    const numToAnimate = Math.floor(Math.random() * 5) + 1; // Выбираем от 1 до 5 rect
    const randomRects = rectsArray
      .sort(() => 0.5 - Math.random())
      .slice(0, numToAnimate); // Перемешиваем и берем нужное кол-во

    randomRects.forEach((rect) => {
      const duration = Math.random() * 1.5 + 0.5; // Время анимации от 0.5 до 2 сек

      rect.style.fill = "#00C0D1"; // Изменяем цвет

      setTimeout(() => {
        rect.style.fill = "#806DE5";
      }, duration * 1000 + 500); // Возвращаем в исходное положение
    });

    // Повторяем через 5-10 секунд
    setTimeout(animateRandomRects, Math.random() * 5000);
  };

  animateRandomRects();
});
</script>
<template>
  <div class="container">
    <div class="head-row col-mob">
      <div class="content__block menu-block">
        <div class="menu">
          <h2 class="head-h2">Организации</h2>
          <div class="tabs">
            <div class="tab active">Все</div>
          </div>
        </div>
      </div>
      <div class="companies">
        <div
          v-for="company in companies"
          :key="company.id"
          class="content__block"
        >
          <div class="company">
            <div class="company__info">
              <img
                class="company__img"
                :src="'https://api.feedback.agl.center/uploads' + company.logo"
                alt=""
              />
              <div class="head-h2">{{ company.ur_name }}</div>
              <div v-if="company.rating" class="head-22 center">
                {{ company.rating.toFixed(2)}}
                <StarsRating
                  :rating="company.rating.toFixed(2)"
                  :indexpath="company.id"
                  :size="24"
                />
              </div>
            </div>
            <div class="head-22">
              {{ company.description }}
            </div>
            <router-link class="btn" :to="'/company/' + company.id">
              перейти
            </router-link>
          </div>
        </div>
        <div class="content__block black banner">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="248"
            height="124"
            viewBox="0 0 248 124"
            fill="none"
          >
            <rect
              x="0.580261"
              y="7.56396"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-45 0.580261 7.56396)"
              fill="#806DE5"
            />
            <rect
              x="0.580261"
              y="69.8629"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-45 0.580261 69.8629)"
              fill="#806DE5"
            />
            <rect
              x="61.3214"
              y="116.45"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(135 61.3214 116.45)"
              fill="#00C0D1"
            />
            <rect
              x="63.6639"
              y="69.8629"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-45 63.6639 69.8629)"
              fill="#806DE5"
            />
            <rect
              x="53.8377"
              y="0.079834"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 53.8377 0.079834)"
              fill="#806DE5"
            />
            <rect
              x="53.8377"
              y="0.0495605"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 53.8377 0.0495605)"
              fill="#806DE5"
            />
            <rect
              x="53.8377"
              y="63.1627"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 53.8377 63.1627)"
              fill="#00C0D1"
            />
            <rect
              x="85.0027"
              y="0.0495605"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 85.0027 0.0495605)"
              fill="#806DE5"
            />
            <rect
              x="8.06401"
              y="123.15"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-135 8.06401 123.15)"
              fill="#806DE5"
            />
            <rect
              x="41.1968"
              y="33.6605"
              width="10.6079"
              height="24.6635"
              rx="5.30397"
              fill="#806DE5"
            />
            <rect
              x="103.254"
              y="2.52625"
              width="10.5549"
              height="24.6635"
              rx="5.27745"
              fill="#806DE5"
            />
            <rect
              x="103.254"
              y="64.848"
              width="10.5549"
              height="24.6635"
              rx="5.27745"
              fill="#00C0D1"
            />
            <rect
              x="27.6715"
              y="40.7148"
              width="10.6079"
              height="24.6635"
              rx="5.30397"
              transform="rotate(90 27.6715 40.7148)"
              fill="#806DE5"
            />
            <rect
              x="120.863"
              y="103.832"
              width="10.6079"
              height="24.6635"
              rx="5.30397"
              transform="rotate(90 120.863 103.832)"
              fill="#00C0D1"
            />
            <rect
              x="85.0027"
              y="31.2141"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 85.0027 31.2141)"
              fill="#806DE5"
            />
            <rect
              x="85.0027"
              y="93.5433"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 85.0027 93.5433)"
              fill="#00C0D1"
            />
            <rect
              x="116.362"
              y="31.2141"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 116.362 31.2141)"
              fill="#806DE5"
            />
            <rect
              x="123.847"
              y="7.56396"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-45 123.847 7.56396)"
              fill="#806DE5"
            />
            <rect
              x="123.847"
              y="69.8629"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-45 123.847 69.8629)"
              fill="#806DE5"
            />
            <rect
              x="184.588"
              y="116.45"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(135 184.588 116.45)"
              fill="#00C0D1"
            />
            <rect
              x="186.931"
              y="69.8629"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-45 186.931 69.8629)"
              fill="#806DE5"
            />
            <rect
              x="177.105"
              y="0.079834"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 177.105 0.079834)"
              fill="#806DE5"
            />
            <rect
              x="177.105"
              y="0.0495605"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 177.105 0.0495605)"
              fill="#806DE5"
            />
            <rect
              x="177.105"
              y="63.1627"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 177.105 63.1627)"
              fill="#00C0D1"
            />
            <rect
              x="208.27"
              y="0.0495605"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 208.27 0.0495605)"
              fill="#806DE5"
            />
            <rect
              x="131.331"
              y="123.15"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-135 131.331 123.15)"
              fill="#00C0D1"
            />
            <rect
              x="164.464"
              y="33.6605"
              width="10.6079"
              height="24.6635"
              rx="5.30397"
              fill="#806DE5"
            />
            <rect
              x="226.52"
              y="2.52625"
              width="10.5549"
              height="24.6635"
              rx="5.27745"
              fill="#806DE5"
            />
            <rect
              x="226.52"
              y="64.848"
              width="10.5549"
              height="24.6635"
              rx="5.27745"
              fill="#806DE5"
            />
            <rect
              x="150.94"
              y="40.7148"
              width="10.6079"
              height="24.6635"
              rx="5.30397"
              transform="rotate(90 150.94 40.7148)"
              fill="#806DE5"
            />
            <rect
              x="244.129"
              y="103.832"
              width="10.6079"
              height="24.6635"
              rx="5.30397"
              transform="rotate(90 244.129 103.832)"
              fill="#00C0D1"
            />
            <rect
              x="186.147"
              y="38.6984"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(-45 186.147 38.6984)"
              fill="#806DE5"
            />
            <rect
              x="208.27"
              y="93.5433"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 208.27 93.5433)"
              fill="#00C0D1"
            />
            <rect
              x="239.629"
              y="31.2141"
              width="10.5842"
              height="31.2862"
              rx="5.29209"
              transform="rotate(45 239.629 31.2141)"
              fill="#806DE5"
            />
          </svg>
          <div class="project__info">
            <div class="head__project">Уникальная система оценки компаний</div>
            <div class="description__project">
              Не позволительная роскошь в 2025 году заниматься бездельем,
              сегодня мы лучше чем вчера.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.center{
  align-items: center;
}
.tabs {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
rect {
  transition: all 0.3s ease-in-out;
}
.tab {
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  padding: 5px 10px;
  border-radius: 25px;
  background: #f3f1f1;
}
.tab.active {
  background: #806de5;
  color: #fff;
}
.menu {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.company__info {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 15px;
  align-items: center;
}
.company__img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}
.companies {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.company__info .head-h2 {
  margin-right: auto;
}
.company {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.companies .content__block {
  justify-content: flex-start;
}
.project__info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  height: 100%;
}
.head__project {
  color: #fff;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 32px */
  max-width: 390px;
}
.description__project {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.banner {
  gap: 30px;
}
@media screen and (max-width: 990px) {
  .menu {
    gap: 20px;
  }
  .companies .content__block {
    flex-direction: column;
    gap: 20px;
  }
  .head__project {
    font-size: 24px;
  }
}
</style>